// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"f3dee437","157":"fdb2a19c","180":"17b877eb","341":"14cc45a3","625":"a70ba059","845":"7b264243","967":"1dac809f"}[chunkId] + ".chunk.js";
};